import { useTranslation } from "react-i18next";
import { PaymentStatus } from "../../domain/types";

const STATUS_CLASSES: Record<PaymentStatus, string> = {
    draft: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300",
    pending: "bg-accent-tint text-accent-text dark:bg-accent/15",
    paid: "bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-300",
    cancelled: "bg-red-50 text-red-700 dark:bg-red-500/15 dark:text-red-300",
};

const PaymentStatusBadge: React.FC<{ status: PaymentStatus }> = ({ status }) => {
    const { t } = useTranslation();
    return (
        <span
            // Colour alone never carries the meaning: the label is always
            // present, and the role exposes it to assistive technology.
            role="status"
            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_CLASSES[status]}`}
        >
            {t(`payments.status.${status}`)}
        </span>
    );
};

export default PaymentStatusBadge;
